module.exports = __webpack_public_path__ + "img/verticallayout.d03f2a0d.png";